<div class="wallboardViewSlide" [attr.mid]="moduleKey" [ngStyle]="{'background-image':'url(../Admin/ImageResizer.aspx?imgid=' + backgroundID + '&w=1920&h=1080)'}">
    <div class="wallboardViewSlideContentArea wallboardViewSlideContentAreaLight mt-2 d-flex flex-column">
        <div class="wvStaticContent">
            <div class="wvHeader row align-items-center">
                <!--Title-->
                <div class="wvTitle col-md-6 col-sm-5 col-12">
                    <div class="h-100 d-flex align-items-center pl-2" [ngStyle]="{'background-color': hasBackdrop ? 'rgba(0,0,0,0.4)' : 'transparent'}">
                        <span class="slideTitle">{{currentAgentStatesState?.SlideTitle}}</span>
                    </div>
                </div>

                <!--  Totals  -->
                <div class="wvTotals col-lg-6 col-md-6 col-sm-7 col-12">
                    <!-- Mobile Layout -->
                    <div class="wvTotals-mobile align-items-center h-100" [ngStyle]="{'background-color': hasBackdrop ? 'rgba(0,0,0,0.4)' : 'transparent'}">
                        <div class="d-flex justify-content-between w-100 px-1">
                            <div class="callsInQueue col-3 pl-1 pr-0">
                                <div class="counter-text" cvLocalizedText langSection="Queue_Counter" langKey="Contacts_In_Queue">Contacts in Queue</div>
                                <div class="counter-text">{{currentAgentStatesData?.CallsInQueueCount}}</div>
                            </div>
                            <div class="longestCallInQueue col-6 px-0">
                                <div class="counter-text" cvLocalizedText langSection="Module" langKey="Longest_Call_In_Queue">Longest Contact in Queue</div>
                                <div class="counter-text">{{currentAgentStatesData?.LongestCallInQueueFormatted}}</div>
                            </div>
                            <div class="totalAgents col-3 px-0">
                                <div class="counter-text" cvLocalizedText langSection="Module" langKey="Total_Agents">Total Agents</div>
                                <div class="d-flex justify-content-center counter-text">{{currentAgentStatesData?.TotalCount}}</div>
                            </div>
                        </div>
                    </div>

                    <!-- Desktop Layout -->
                    <div class="wvTotals-desktop align-items-center h-100">
                        <div class="wvQueue h-100 me-2" [ngStyle]="{'background-color': hasBackdrop ? 'rgba(0,0,0,0.4)' : 'transparent'}">
                            <div class="d-flex align-items-center h-100">
                                <div class="col-5 pl-2">
                                    <div class="counter-text" cvLocalizedText langSection="Queue_Counter" langKey="Contacts_In_Queue">Calls in Queue</div>
                                    <div class="counter-text">{{currentAgentStatesData?.CallsInQueueCount}}</div>
                                </div>
                                <div class="col-7 px-2">
                                    <div class="counter-text" cvLocalizedText langSection="Module" langKey="Longest_Call_In_Queue">Longest Call in Queue</div>
                                    <div class="counter-text">{{currentAgentStatesData?.LongestCallInQueueFormatted}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="wvTotalAgents h-100" [ngStyle]="{'background-color': hasBackdrop ? 'rgba(0,0,0,0.4)' : 'transparent'}">
                            <div class="d-flex justify-content-center align-items-center h-100 flex-column">
                                <div class="counter-text" cvLocalizedText langSection="Module" langKey="Total_Agents">Total Agents</div>
                                <div class="counter-text">{{currentAgentStatesData?.TotalCount}}</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- State counters -->
            <div class="wStateCounters">
                <div class="wvCurrentAgentStatesTitle d-flex align-items-center h-100 px-2" [ngStyle]="{'background-color': hasBackdrop ? 'rgba(0,0,0,0.4)' : 'transparent'}">
                    <!--Inbound-->
                    <div class="mx-0">
                        <span class="wvCASName" cvLocalizedText langSection="Wallboard_Management" langKey="Inbound">Inbound</span>
                        <span class="wvCurrentAgentStatesStateBox wInboundCount px-1">{{currentAgentStatesData?.InboundCount}}</span>
                    </div>
                    <!--Outbound-->
                    <div class="mx-0">
                        <span class="wvCASName" cvLocalizedText langSection="Wallboard_Management" langKey="Outbound">Outbound</span>
                        <span class="wvCurrentAgentStatesStateBox wOutboundCount px-1">{{currentAgentStatesData?.OutboundCount}}</span>
                    </div>
                    <!--Available-->
                    <div class="mx-0">
                        <span class="wvCASName" cvLocalizedText langSection="Wallboard_Management" langKey="Available">Available</span>
                        <span class="wvCurrentAgentStatesStateBox wAvailableCount px-1">{{currentAgentStatesData?.AvailableCount}}</span>
                    </div>
                    <!--Unavailable-->
                    <div class="mx-0">
                        <span class="wvCASName" cvLocalizedText langSection="Wallboard_Management" langKey="Unavailable">Unavailable</span>
                        <span class="wvCurrentAgentStatesStateBox wUnavailableCount px-1">{{currentAgentStatesData?.UnavailableCount}}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Table -->
        <div class="clearBoth"></div>
        <div class="layout-desktop table-container" [ngStyle]="{'background-color': hasBackdrop ? 'rgba(0,0,0,0.4)' : 'transparent'}">
            <table class="data-table w-100 h-100 p-1" *ngIf="paddedData?.length > 0">
                <thead #theadElement>
                    <tr>
                        <th class="wGroupName" cvLocalizedText langSection="Module" langKey="Name_Header">Name</th>
                        <th class="wStateName" cvLocalizedText langSection="Module" langKey="State_Header">State</th>
                        <th class="wTime" cvLocalizedText langSection="Module" langKey="Time_Header">Time</th>
                        <th class="wTeam" cvLocalizedText langSection="Module" langKey="Team_Header">Team</th>
                        <th class="wSource" cvLocalizedText langSection="Module" langKey="Source_Header">Source</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let item of paddedData; let $index = index;">
                        <tr>
                            <td class="wGroupName">
                                <div class="d-flex">
                                    <div class="wvCurrentAgentStatesStateIndicator" [ngStyle]="{'background-color': getStateColor(item.state), 'grid-row-start':$index+2}"></div>
                                    <div class="wvCASEllip ms-2" [ngStyle]="{'grid-row-start':$index+2}">
                                        {{item.groupName}}
                                    </div>
                                </div>
                            </td>
                            <td class="wStateName">
                                <div class="wvCASEllip" [ngStyle]="{'grid-row-start':$index+2}">
                                    {{item.stateName}}
                                </div>
                            </td>
                            <td class="wTime wvTimeCell">
                                <div class="wvCASEllip" [ngStyle]="{'grid-row-start':$index+2}">
                                    {{item.stateTime}}
                                </div>
                            </td>
                            <td class="wTeam">
                                <div class="wvCASEllip" [ngStyle]="{'grid-row-start':$index+2}">
                                    {{item.parentGroupName}}
                                </div>
                            </td>
                            <td class="wSource">
                                <div class="wvCASEllip" [ngStyle]="{'grid-row-start':$index+2}">
                                    {{item.skill == "" ? "---" : item.skill}}
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>

        <!-- Cards -->
        <div class="layout-mobile card-container">
            <ng-container *ngFor="let item of paddedData; let $index = index;">
                <div class="wvAgentCard rounded w-100" [ngStyle]="{'background-color': hasBackdrop ? 'rgba(0,0,0,0.4)' : 'transparent'}">
                    <div class="card-item row align-items-center px-2 pt-1 h-100">
                        <div class="col-5 text-start d-flex align-items-center">
                            <div class="wvCurrentAgentStatesStateIndicator mr-2 pr-2" [ngStyle]="{'background-color': getStateColor(item.state)}"></div>
                            <div class="d-flex flex-column">
                                <div class="wvCASEllip">{{item.groupName}}</div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="wvCASEllip">{{item.parentGroupName}}</div>
                        </div>
                        <div class="col-3 d-flex align-items-center justify-content-end wv-time-mobile">
                            <span>{{item.stateTime}}</span>
                        </div>
                    </div>
                    <div class="card-item-min row align-items-center px-2 pt-1">
                        <div class="col-8 text-start">
                            <div class="d-flex align-items-center">
                                <div class="wvCurrentAgentStatesStateIndicator mr-2 pr-2" [ngStyle]="{'background-color': getStateColor(item.state)}"></div>
                                <div class="d-flex flex-column">
                                    <div class="wvCASEllip">{{item.groupName}}</div>
                                    <div class="wvCASEllip">{{item.parentGroupName}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="d-flex align-items-center justify-content-end wv-time-mobile">
                                <span>{{item.stateTime}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
